import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/Activities.css";
import { formatDate } from "../helpers/dateFormat";
import { useTranslation } from "react-i18next";

const Activities = () => {
  const { t, i18n } = useTranslation();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_APP_URL}/get-activities`,
          {
            headers: {
              "X-Platform": process.env.REACT_APP_X_PLATFORM,
              "API-Key": process.env.REACT_APP_API_KEY,
              "X-API-Version": process.env.REACT_APP_X_API_VERSION,
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        );

        if (response.data.success) {
          setActivities(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError("Failed to fetch activities.");
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, [i18n.language, t]);

  if (loading)
    return (
      <div className="activities-container">
        <h2 className="activities-title">{t("yourActivities")}</h2>
        <div className="activities-grid">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="activity-card shimmer-card">
              <div className="activities-shimmer shimmer-title"></div>
              <div className="activities-shimmer shimmer-text"></div>
              <div className="activities-shimmer shimmer-text"></div>
              <div className="activities-shimmer shimmer-badge"></div>
              <div className="activities-shimmer shimmer-badge"></div>
            </div>
          ))}
        </div>
      </div>
    );

  if (error)
    return (
      <div className="error-container">
        <p className="error-text">{error}</p>
      </div>
    );

  return (
    <div className="activities-container">
      <h2 className="activities-title">{t("yourActivities")}</h2>
      {activities.length === 0 ? (
        <p className="no-reservations">{t("noReservation")}</p>
      ) : (
        <div className="activities-grid">
          {activities.map((activity) => (
            <div
              key={activity.id}
              className="activity-card"
              onClick={() => navigate(`/dashboard/activities/${activity.id}`)}
            >
              <div className="activity-content">
                <h3 className="activity-title">{activity.booking_reference}</h3>
                <p className="room-type-name">{activity.room_type.name}</p>
                <p className="activity-date">
                  <strong>Check-in:</strong>{" "}
                  {formatDate(activity.check_in_date)}
                </p>
                <p className="activity-date">
                  <strong>Check-out:</strong>{" "}
                  {formatDate(activity.check_out_date)}
                </p>
                <p className="activity-status">
                  <strong>Status:</strong>{" "}
                  <span className={`status-badge ${activity.status}`}>
                    {activity.status.replace("_", " ").toUpperCase()}
                  </span>
                </p>
                <p className="activity-status">
                  <strong>{t("payment")}:</strong>{" "}
                  <span className={`payment-badge ${activity.status_payment}`}>
                    {activity.status_payment.replace("_", " ").toUpperCase()}
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Activities;
